(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["expandable-icon-grid"] && !Shopify.designMode) return;
  try {
    (function () {
    function initExpandableGrid(root) {
      var toggle = root.querySelector('[data-expandable-grid-toggle]');
      var target = root.querySelector('.expandable-icon-grid__more');
      var label = root.querySelector('[data-expandable-grid-label]');
      if (!toggle || !target) return;

      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        var next = !expanded;
        toggle.setAttribute('aria-expanded', String(next));
        if (next) {
          target.removeAttribute('hidden');
          if (label) label.textContent = toggle.dataset.labelLess;
        } else {
          target.setAttribute('hidden', '');
          if (label) label.textContent = toggle.dataset.labelMore;
        }
      });
    }

    document.querySelectorAll('[data-expandable-grid]').forEach(initExpandableGrid);
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target && e.target.matches('[data-expandable-grid]')) initExpandableGrid(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["expandable-richtext"] && !Shopify.designMode) return;
  try {
    (function () {
    function initExpandable(root) {
      var toggle = root.querySelector('[data-expandable-toggle]');
      var target = root.querySelector('.expandable-richtext__more');
      if (!toggle || !target) return;

      var labelEl = toggle.querySelector('.expandable-richtext__toggle-label');
      var labelMore = toggle.dataset.labelMore;
      var labelLess = toggle.dataset.labelLess;

      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        var next = !expanded;
        toggle.setAttribute('aria-expanded', String(next));
        if (next) {
          target.removeAttribute('hidden');
          if (labelEl) labelEl.textContent = labelLess;
        } else {
          target.setAttribute('hidden', '');
          if (labelEl) labelEl.textContent = labelMore;
        }
      });
    }

    document.querySelectorAll('[data-expandable]').forEach(initExpandable);
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target && e.target.matches('[data-expandable]')) initExpandable(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var emblaRoots = document.querySelectorAll('[data-gallery-embla]');

    emblaRoots.forEach(function (root) {
      var viewport = root.querySelector('[data-gallery-embla-viewport]');
      if (!viewport || !window.EmblaCarousel) {
        return;
      }

      var slideCount = viewport.querySelectorAll('[data-gallery-embla-container] > *').length;

      var prevBtn = root.querySelector('[data-gallery-embla-prev]');
      var nextBtn = root.querySelector('[data-gallery-embla-next]');

      if (slideCount <= 1) {
        if (prevBtn) {
          prevBtn.hidden = true;
        }
        if (nextBtn) {
          nextBtn.hidden = true;
        }
        return;
      }

      var embla = EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        loop: true,
        slidesToScroll: 1
      });

      var slides = embla.slideNodes();

      function eagerLoadSlide(index) {
        var slide = slides[(index + slides.length) % slides.length];
        slide.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.loading = 'eager';
        });
      }

      function eagerLoadNearby() {
        embla.slidesInView().forEach(function (index) {
          eagerLoadSlide(index - 1);
          eagerLoadSlide(index);
          eagerLoadSlide(index + 1);
        });
      }

      embla.on('slidesInView', eagerLoadNearby);
      eagerLoadNearby();

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          embla.scrollPrev();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          embla.scrollNext();
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
